import React from 'react';
import { Spinner } from '@xendit/ui-toolkit';
import styles from './styles.module.css';
export const FullScreenLoading = () => {
    return (React.createElement("div", { className: styles['full-screen-loading'] },
        React.createElement(Spinner, { size: "lg" })));
};
